import React, { useState } from 'react';
import { FaShare } from 'react-icons/fa';
import ShareModal from './ShareModal';
import './ContentShareButton.css';

/**
 * Share pill + ShareModal (same flow as VideoList). Stops propagation so parent cards/links do not navigate.
 */
const ContentShareButton = ({ shareUrl, title, type = 'post', className = '' }) => {
    const [open, setOpen] = useState(false);

    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setOpen(true);
    };

    return (
        <>
            <button
                type="button"
                className={`content-share-btn ${className}`.trim()}
                onClick={handleClick}
                title="Share"
            >
                <FaShare className="content-share-btn__icon" aria-hidden />
                Share
            </button>
            <ShareModal
                isOpen={open}
                onClose={() => setOpen(false)}
                shareUrl={shareUrl}
                title={title || 'Untitled'}
                type={type}
            />
        </>
    );
};

export default ContentShareButton;
